import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Grid,
  Skeleton,
  Tab,
  Tabs,
  Typography,
  SvgIcon,
  Button,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import RestakeImage from "src/assets/images/restake.png";
import { ReactComponent as StarIcon } from "src/assets/icons/star.svg";
import { useAppSelector, useMobile } from "src/hooks";
import { useSelector, useStore } from "react-redux";
import { loadAppDetails } from "src/slices/AppSlice";
import RestakeIcon from "src/assets/icons/restake.svg";
import RebaseTimer from "../../components/RebaseTimer/RebaseTimer";
import { Trans, t } from "@lingui/macro";
import { trim, toolNumber, customNumberFormat } from "../../helpers";
import { useWeb3Context } from "src/hooks/web3Context";
import { ReactComponent as CalcIcon } from "src/assets/icons/calc.svg";
import { LoadingButton } from "@mui/lab";
import { isPendingTxn, txnButtonText } from "src/slices/PendingTxnsSlice";
import { error } from "../../slices/MessagesSlice";
import { useDispatch } from "react-redux";
import { ethers } from "ethers";
import { changeApproval, changeRestake } from "../../slices/ReStakeThunk";
import { getBalances, getBurnAmount, getRestakingRecords, loadAccountDetails } from "src/slices/AccountSlice";
import RestakeRecord from "./RestakeRecord";
import { addresses, INVITE_PER_PAGE } from "src/constants";
import AdvancedSettings from "./AdvancedSettings";
import { ReactComponent as SettingsIcon } from "../../assets/icons/settings.svg";
import { ClickAwayListener } from "@material-ui/core";
import { getRestakeAmountsOut } from "src/slices/SwapThunk";
import useDebounce from "src/hooks/Debounce";
import logger from "src/utils/logger";
import CalculatorModal from "../Stake/Calculator";

const Restake = () => {
  const { isSmallScreen } = useMobile();
  const { provider, address, connected, connect, chainID } = useWeb3Context();
  const dispatch = useDispatch();

  const [tab, setTab] = useState(0); //day tab
  const [view, setView] = useState(0); //restaking type
  const [quantity, setQuantity] = useState<any>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [open, setOpen] = useState(false);
  const [slippage, setSlippage] = useState(localStorage.getItem("restakeSlippage") || 0.1);
  const [recipientAddress, setRecipientAddress] = useState(address);
  const [isBtn, setIsBtn] = useState(localStorage.getItem("isBtnRestake") || "btn");
  const isAppLoading = useAppSelector(state => state.app.loading);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const ohmBalance = useAppSelector(state => {
    return state.account.balances && state.account.balances.ohm;
  });

  const fiveDayRate = useAppSelector(state => {
    return state.app.fiveDayRate;
  });
  const restakingPool90Rebase = useAppSelector(state => {
    return state.app.restakingPool90Rebase || 0;
  });
  const restakingPool180Rebase = useAppSelector(state => {
    return state.app.restakingPool180Rebase || 0;
  });
  const restakingPool360Rebase = useAppSelector(state => {
    return state.app.restakingPool360Rebase || 0;
  });
  const restakingPool90APY = useAppSelector(state => {
    return state.app.restakingPool90APY ? toolNumber(state.app.restakingPool90APY) : 0;
  });
  const restakingPool180APY = useAppSelector(state => {
    return state.app.restakingPool180APY ? toolNumber(state.app.restakingPool180APY) : 0;
  });
  const restakingPool360APY = useAppSelector(state => {
    return state.app.restakingPool360APY ? toolNumber(state.app.restakingPool360APY) : 0;
  });
  const restakingPool90FiveDayRate = useAppSelector(state => {
    return state.app.restakingPool90FiveDayRate;
  });
  const restakingPool180FiveDayRate = useAppSelector(state => {
    return state.app.restakingPool180FiveDayRate;
  });
  const restakingPool360FiveDayRate = useAppSelector(state => {
    return state.app.restakingPool360FiveDayRate;
  });
  const sohmPrincipalInRestakingPool90 = useAppSelector(state => {
    return state.app.sohmPrincipalInRestakingPool90;
  });
  const sohmPrincipalInRestakingPool180 = useAppSelector(state => {
    return state.app.sohmPrincipalInRestakingPool180;
  });
  const sohmPrincipalInRestakingPool360 = useAppSelector(state => {
    return state.app.sohmPrincipalInRestakingPool360;
  });
  const ohmBalInRestakingPool90 = useAppSelector(state => {
    return state.app.ohmBalInRestakingPool90;
  });
  const ohmBalInRestakingPool180 = useAppSelector(state => {
    return state.app.ohmBalInRestakingPool180;
  });
  const ohmBalInRestakingPool360 = useAppSelector(state => {
    return state.app.ohmBalInRestakingPool360;
  });

  const stakeAllowance = useAppSelector(state => {
    return state.account.staking && state.account.staking.ohmStake;
  });

  const unstakeAllowance = useAppSelector(state => {
    return state.account.staking && state.account.staking.ohmUnstake;
  });
  const tokenBalInStaking = useAppSelector(state => {
    return state.app.tokenBalInStaking || 0;
  });
  const tokenPrice = useAppSelector(state => {
    return state.app.marketPrice;
  });
  const principalAmt = useAppSelector(state => {
    return state.account.balances && state.account.balances.principalAmt;
  });
  const usdtBalance = useAppSelector(state => {
    return state.account.balances && state.account.balances.dai;
  });
  const interestBal = useAppSelector(state => {
    return state.account.balances && state.account.balances.interest;
  });
  const avaiablePrincipalAmt = useAppSelector(state => {
    return state.account.balances && state.account.balances.avaiablePrincipalAmt;
  });
  const sohmBalance = useAppSelector(state => {
    return state.account.balances && state.account.balances.sOHM;
  });
  const pendingTransactions = useAppSelector(state => {
    return state.pendingTransactions;
  });
  const gonsBal = useAppSelector(state => {
    return state.account.balances && state.account.balances.gonsBal;
  });
  const minRestakeAmount = useAppSelector(state => {
    return state.swap.minRestakeAmount;
  });
  const restaking90Principal = useAppSelector(state => {
    return state.account && state.account.restaking90Principal;
  });
  const restaking180Principal = useAppSelector(state => {
    return state.account && state.account.restaking180Principal;
  });
  const restaking360Principal = useAppSelector(state => {
    return state.account && state.account.restaking360Principal;
  });
  const restaking90WithdrawableInterest = useAppSelector(state => {
    return state.account && state.account.restaking90WithdrawableInterest;
  });
  const restaking180WithdrawableInterest = useAppSelector(state => {
    return state.account && state.account.restaking180WithdrawableInterest;
  });
  const restaking360WithdrawableInterest = useAppSelector(state => {
    return state.account && state.account.restaking360WithdrawableInterest;
  });
  const flashRestakingUsdtAllowance = useAppSelector(state => state.account.flashRestakingUsdtAllowance);
  const flashRestakingSohmAllowance = useAppSelector(state => state.account.flashRestakingSohmAllowance);
  const flashRestakingOhmAllowance = useAppSelector(state => state.account.flashRestakingOhmAllowance);
  const restaking90Allowance = useAppSelector(state => {
    return state.account && state.account.restaking90Allowance;
  });
  const restaking180Allowance = useAppSelector(state => {
    return state.account && state.account.restaking180Allowance;
  });
  const restaking360Allowance = useAppSelector(state => {
    return state.account && state.account.restaking360Allowance;
  });
  const restakingAllowance = [restaking360Allowance, restaking180Allowance, restaking90Allowance];
  const restakingWithdrawableInterest = [
    restaking360WithdrawableInterest,
    restaking180WithdrawableInterest,
    restaking90WithdrawableInterest,
  ];
  const totalRestakingWithdrawableInterest =
    Number(restaking90WithdrawableInterest) +
    Number(restaking180WithdrawableInterest) +
    Number(restaking360WithdrawableInterest);
  console.log("totalRestakingWithdrawableInterest", totalRestakingWithdrawableInterest);
  const stakingAPY = useAppSelector(state => {
    return state.app.stakingAPY ? toolNumber(state.app.stakingAPY) : 0;
  });
  const totalRestakingPrincipal =
    Number(restaking90Principal) + Number(restaking180Principal) + Number(restaking360Principal);
  console.log("totalRestakingPrincipal", {
    totalRestakingPrincipal,
    restaking90Principal,
    restaking180Principal,
    restaking360Principal,
    flashRestakingUsdtAllowance,
    flashRestakingSohmAllowance,
    flashRestakingOhmAllowance,
    restakingAllowance,
    stakeAllowance,
    restaking90Allowance,
    restaking180Allowance,
    restaking360Allowance,
    unstakeAllowance,
    restaking90WithdrawableInterest,
    restaking180WithdrawableInterest,
    restaking360WithdrawableInterest,
  });
  const stakingTVL = (tokenPrice as number) * tokenBalInStaking;
  const staking90TVL =
    (tokenPrice as number) * (Number(sohmPrincipalInRestakingPool90) + Number(ohmBalInRestakingPool90));
  const staking180TVL =
    (tokenPrice as number) * (Number(sohmPrincipalInRestakingPool180) + Number(ohmBalInRestakingPool180));
  const staking360TVL =
    (tokenPrice as number) * (Number(sohmPrincipalInRestakingPool360) + Number(ohmBalInRestakingPool360));
  const isAllowanceDataLoading =
    (flashRestakingUsdtAllowance == null && flashRestakingSohmAllowance == null && view === 0) ||
    (Number(restakingAllowance?.[tab]) == null && flashRestakingOhmAllowance == null && view === 1);
  console.log("Redux state changed isAllowanceDataLoading", {
    flashRestakingUsdtAllowance,
    flashRestakingSohmAllowance,
    restaking90Allowance,
    restaking180Allowance,
    restaking360Allowance,
    restakingAllowance: restakingAllowance?.[tab],
    tab,
    view,
    isAllowanceDataLoading,
  });
  // const store = useStore();

  // useEffect(() => {
  //   const unsubscribe = store.subscribe(() => {
  //     console.log("Redux state changed:", store.getState().account.restaking);
  //   });
  //   return unsubscribe;
  // }, []);
  const changeView = (_event: React.ChangeEvent<{}>, newView: number) => {
    setView(newView);
    (quantity || quantity == 0) && setQuantity("");
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const hasAllowance = useCallback(
    token => {
      if (token === "sOHM") {
        // 在 Flash Staking 模式下使用 flashRestakingSohmAllowance，否则使用 restakingAllowance
        if (view === 0) {
          return flashRestakingSohmAllowance ? flashRestakingSohmAllowance > 0 : 0;
        } else {
          return Number(restakingAllowance?.[tab]) > 0;
        }
      }
      if (token === "USDT") return flashRestakingUsdtAllowance ? flashRestakingUsdtAllowance > 0 : 0;
      if (token === "OHM") return flashRestakingOhmAllowance ? flashRestakingOhmAllowance > 0 : 0;
      return 0;
    },
    [
      restaking90Allowance,
      restaking180Allowance,
      restaking360Allowance,
      tab,
      view,
      flashRestakingUsdtAllowance,
      flashRestakingOhmAllowance,
      flashRestakingSohmAllowance,
    ],
  );

  const loadReStakingData = useCallback(async () => {
    if (!address || !provider || !chainID) return;
    console.log("loadReStakingData getBalances");
    await Promise.all([
      dispatch(getBalances({ address, networkID: chainID, provider })),
      dispatch(
        getRestakingRecords({
          address,
          provider,
          networkID: chainID,
        }),
      ),
    ]);
  }, [address, chainID, provider, dispatch]);

  useEffect(() => {
    loadReStakingData();
  }, [address]);

  const onAmountChange = (event: any) => {
    let value = event.target.value;

    // 限制最多9位小数
    if (value.includes(".")) {
      const parts = value.split(".");
      if (parts[1] && parts[1].length > 9) {
        value = parts[0] + "." + parts[1].slice(0, 9);
      }
    }

    setQuantity(value);
  };

  // const restakeDebounce = useDebounce(quantity, 500);

  // useEffect(() => {
  //   dispatch(
  //     getRestakeAmountsOut({
  //       poolType: tab,
  //       amountIn: quantity,
  //       provider,
  //       networkID: chainID,
  //     }),
  //   );
  // }, [restakeDebounce]);

  const setMax = () => {
    if (view == 0) {
      setQuantity(trim(Number(usdtBalance), 4));
    } else if (view == 1) {
      setQuantity(trim(Number(ohmBalance), 4));
    } else {
      setQuantity(trim(Number(restakingWithdrawableInterest?.[tab]), 4));
    }
  };
  const stakingRebase = useAppSelector(state => {
    return state.app.stakingRebase || 0;
  });
  const onChangeRestake = async (action: string) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(quantity) || quantity == 0) {
      // eslint-disable-next-line no-alert
      return dispatch(error(t`Please enter a value!`));
    } else if (quantity < 0) {
      return dispatch(error(t`Please enter a valid value!`));
    }
    // console.log("qua", quantity);
    // 1st catch if quantity > balance
    let gweiValue = ethers.utils.parseUnits(quantity.toString(), view === 0 ? "18" : "9");
    console.log("gweiValue", gweiValue);
    if (action === "flashRestaking" && gweiValue.gt(ethers.utils.parseUnits(usdtBalance, "18"))) {
      return dispatch(error(t`You cannot flash restake more than your USDT balance.`));
    }

    if (action === "restaking" && gweiValue.gt(ethers.utils.parseUnits(ohmBalance, "9"))) {
      // return dispatch(error(t`Insufficient available principal!`));
      return dispatch(error(t`You cannot restake more than your OHM balance.`));
    }
    if (
      action === "unrestaking_interest" &&
      gweiValue.gt(ethers.utils.parseUnits(restakingWithdrawableInterest?.[tab], "9"))
    ) {
      return dispatch(error(t`You cannot restake more than your interest balance.`));
    }

    await dispatch(
      changeRestake({
        address,
        action,
        value: quantity.toString(),
        provider,
        networkID: chainID,
        restakingType: [2, 1, 0][tab],
      }),
    );
    // await Promise.resolve(new Promise(resolve => setTimeout(resolve, 1000)));
    setQuantity(0);
    // Promise.all([
    await dispatch(loadAppDetails({ networkID: chainID, provider }));
    dispatch(getRestakingRecords({ address, provider, networkID: chainID }));
    // ]);
  };

  const onUnrestakeInterest = async () => {
    if (quantity == 0) {
      return dispatch(error(t`Please enter a value!`));
    } else if (quantity < 0) {
      return dispatch(error(t`Please enter a valid value!`));
    }
    let gweiValue = ethers.utils.parseUnits(quantity.toString(), view === 0 ? "18" : "9");
    if (gweiValue.gt(ethers.utils.parseUnits(restakingWithdrawableInterest?.[tab], "9"))) {
      return dispatch(error(t`You cannot restake more than your interest balance.`));
    }
    await dispatch(
      changeRestake({
        address,
        action: "unrestaking_interest",
        value: quantity.toString(),
        provider,
        networkID: chainID,
        restakingType: [2, 1, 0][tab],
      }),
    );
  };

  const onSeekApproval = async (token: string, isFlashRestaking: boolean) => {
    await dispatch(
      changeApproval({ address, token, provider, networkID: chainID, restakingPoolType: tab, isFlashRestaking }),
    );
    // console.log("loadAccountDetails approve staking", {
    //   stakeAllowance,
    //   unstakeAllowance,
    // });
    await Promise.all([
      dispatch(
        loadAccountDetails({
          address,
          provider,
          networkID: chainID,
        }),
      ),
      dispatch(getBalances({ address, networkID: chainID, provider })),
    ]);
    // console.log("loadAccountDetails approve staking", {
    //   stakeAllowance,
    //   unstakeAllowance,
    // });
  };

  const onSlippageChange = (value: string, isBtn: string) => {
    if (isBtn == "ipt") {
      if (value == "0.1" || value == "0.5" || value == "1.0") {
        setIsBtn("btn");
        setSlippage(value);
        localStorage.setItem("restakeSlippage", value);
        localStorage.setItem("isBtnRestake", "btn");
        return;
      } else {
        localStorage.setItem("isBtnRestake", isBtn);
        localStorage.setItem("restakeSlippage", value);

        setIsBtn(isBtn);
        return setSlippage(value);
      }
    } else {
      localStorage.setItem("isBtnRestake", isBtn);
      localStorage.setItem("restakeSlippage", value);

      setIsBtn(isBtn);
      return setSlippage(value);
    }
  };

  const onSlippageBlur = (value: number) => {
    if (value <= 0) {
      setIsBtn("btn");
      setSlippage("0.1");
      localStorage.setItem("restakeSlippage", "0.1");
      localStorage.setItem("isBtnRestake", "btn");
    }
  };

  const changeTab = useCallback((_event: React.ChangeEvent<{}>, newTab: number) => {
    setTab(newTab);
  }, []);

  const trimmedBalance = Number(
    [sohmBalance]
      .filter(Boolean)
      .map(balance => Number(balance))
      .reduce((a, b) => a + b, 0)
      .toFixed(4),
  );
  const trimmedStakingAPY = stakingAPY * 100;
  const trimmedRestakingPool90APY = restakingPool90APY * 100;
  const trimmedRestakingPool180APY = restakingPool180APY * 100;
  const trimmedRestakingPool360APY = restakingPool360APY * 100;

  // console.log("stakingRebase", stakingRebase);
  // const trimmedStakingAPY = stakingAPY * 100;
  // const trimmedStakingAPY = trim(stakingAPY * 100, 2);
  const stakingRebasePercentage = trim(stakingRebase * 100, 4);
  const restakingPool90RebasePercentage = trim(restakingPool90Rebase * 100, 4);
  const restakingPool180RebasePercentage = trim(restakingPool180Rebase * 100, 4);
  const restakingPool360RebasePercentage = trim(restakingPool360Rebase * 100, 4);
  // const nextRewardValue = (() => {
  //   const rebaseRate = Number(stakingRebasePercentage) || 0;
  //   const balance = Number(trimmedBalance) || 0;
  //   const gonsBalance = Number(gonsBal) || 0;
  //   const totalBalance = balance + gonsBalance;
  //   const result = (rebaseRate / 100) * totalBalance;
  //   return Number.isNaN(result) ? "0" : trim(result, 4);
  // })();
  // 使用usememo 以及判断tab 来写nextRewardValue
  const nextRewardValue = useMemo(() => {
    console.log("nextRewardValue", {
      restakingPool360RebasePercentage,
      restakingPool180RebasePercentage,
      restakingPool90RebasePercentage,
      sohmPrincipalInRestakingPool360,
      sohmPrincipalInRestakingPool180,
      sohmPrincipalInRestakingPool90,
      restakingPool90Rebase,
      restakingPool180Rebase,
      restakingPool360Rebase,
    });

    let result = 0;

    if (tab === 0) {
      // 360天池子
      result =
        (Number(restakingPool360Rebase) || 0) *
        ((Number(restaking360Principal) || 0) + (Number(restaking360WithdrawableInterest) || 0));
    } else if (tab === 1) {
      // 180天池子
      result =
        (Number(restakingPool180Rebase) || 0) *
        ((Number(restaking180Principal) || 0) + (Number(restaking180WithdrawableInterest) || 0));
    } else if (tab === 2) {
      // 90天池子
      result =
        (Number(restakingPool90Rebase) || 0) *
        ((Number(restaking90Principal) || 0) + (Number(restaking90WithdrawableInterest) || 0));
    }

    // 处理 infinity、NaN 和过大数值的情况
    if (!isFinite(result) || isNaN(result)) {
      return "0";
    }

    return result > 0 ? trim(result, 4) : "0";
  }, [
    restakingPool90Rebase,
    restakingPool180Rebase,
    restakingPool360Rebase,
    restaking360Principal,
    restaking360WithdrawableInterest,
    restaking180Principal,
    restaking180WithdrawableInterest,
    restaking90Principal,
    restaking90WithdrawableInterest,
    tab,
  ]);
  const nextRebaseValue = useMemo(() => {
    let result = 0;

    if (tab === 0) {
      result = Number(restakingPool360RebasePercentage) || 0;
    } else if (tab === 1) {
      result = Number(restakingPool180RebasePercentage) || 0;
    } else {
      result = Number(restakingPool90RebasePercentage) || 0;
    }

    // 处理 infinity、NaN 和过大数值的情况
    if (!isFinite(result) || isNaN(result)) {
      return "0";
    }

    return result > 0 ? trim(result, 4) : "0";
  }, [restakingPool360RebasePercentage, restakingPool180RebasePercentage, restakingPool90RebasePercentage, tab]);
  const restakeFiveDayRate = useMemo(() => {
    let result = 0;

    if (tab === 0) {
      result = Number(restakingPool360FiveDayRate) || 0;
    } else if (tab === 1) {
      result = Number(restakingPool180FiveDayRate) || 0;
    } else {
      result = Number(restakingPool90FiveDayRate) || 0;
    }

    // 处理 infinity、NaN 和过大数值的情况
    if (!isFinite(result) || isNaN(result)) {
      return 0;
    }

    return result > 0 ? result : 0;
  }, [restakingPool90FiveDayRate, restakingPool180FiveDayRate, restakingPool360FiveDayRate, tab]);
  const restakedBal = [restaking360Principal, restaking180Principal, restaking90Principal];
  logger.info("Flash Restaking Logic Debug", {
    hasUSDTAllowance: hasAllowance("USDT"),
    hasSOHMAllowance: hasAllowance("sOHM"),
    quantity: quantity,
    flashRestakingUsdtAllowance: flashRestakingUsdtAllowance,
    flashRestakingSohmAllowance: flashRestakingSohmAllowance,
    usdtInsufficientCondition:
      quantity && flashRestakingUsdtAllowance && Number(quantity) > flashRestakingUsdtAllowance,
    shouldShowApproveUSDT:
      !hasAllowance("USDT") ||
      (quantity && flashRestakingUsdtAllowance && Number(quantity) > flashRestakingUsdtAllowance),
    shouldShowApproveSOHM:
      hasAllowance("USDT") &&
      (!quantity || (flashRestakingUsdtAllowance && flashRestakingUsdtAllowance >= Number(quantity))) &&
      !hasAllowance("sOHM"),
    view: view,
    isAllowanceDataLoading: isAllowanceDataLoading,
  });

  // logger.info("change allowance", {
  //   allwoanceohm: hasAllowance("OHM"),
  //   allwoancesohm: hasAllowance("sOHM"),
  //   restakingAllowance,
  //   quantity,
  //   tab: tab,
  //   flashRestakingOhmAllowance,
  //   flashRestakingSohmAllowance,
  //   flashRestakingUsdtAllowance,
  //   restaking90Allowance,
  //   restaking180Allowance,
  //   restaking360Allowance,
  // });
  return (
    <Box
      display="flex"
      alignItems={"center"}
      flexDirection={"column"}
      sx={{
        position: "relative",
        mb: "100px",
      }}
    >
      <Box
        sx={{
          maxWidth: "1340px",
          width: { xs: "100%", sm: "97%" },
          pt: { sm: "87px", xs: "18px" },
          px: { xs: "15px", sm: "0" },
          position: "relative",
          zIndex: "1",
        }}
      >
        {/* restake top */}
        <Box
          display="flex"
          justifyContent={{ xs: "flex-start", sm: "space-between" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          sx={{
            mb: {
              sm: "44px",
              xs: "20px",
            },
          }}
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <Box
            display="flex"
            alignItems={"center"}
            sx={{
              mb: { xs: "15px", sm: "0" },
            }}
          >
            <Box
              sx={{
                mr: { sm: "20px", xs: "12px" },
              }}
            >
              <StarIcon
                style={{
                  width: isSmallScreen ? "37px" : "61px",
                  height: isSmallScreen ? "37px" : "61px",
                }}
              />
            </Box>
            <Box
              sx={{
                "&>img": {
                  width: { xs: "99px", sm: "163px" },
                },
              }}
              display="flex"
              flexDirection={"column"}
              // alignItems={"center"}
              justifyContent={"center"}
            >
              <img src={RestakeIcon} alt="restake" />

              <RebaseTimer />
            </Box>
          </Box>
          <Box
            sx={{
              maxWidth: "900px",
              // maxWidth: "650px",
              width: "100%",
            }}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid
              container
              sx={
                {
                  // width: '100%'
                }
              }
              columnSpacing={2}
              rowSpacing={{ xs: 2.5, sm: 0 }}
            >
              <Grid item xs={12} sm={4}>
                <Box>
                  <Typography
                    sx={{
                      color: "rgba(255, 255, 255, 0.60)",
                      fontSize: "18px",
                      fontWeight: "400",
                      mb: "10px",
                    }}
                    align="center"
                  >
                    <Trans>APY(360Day)</Trans>
                  </Typography>
                  {restakingPool360APY ? (
                    <Typography
                      sx={{
                        fontSize: "24px",
                        fontWeight: "600",
                        color: "#EAECEF",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                      align="center"
                    >
                      {Number(trimmedRestakingPool360APY) >= 0
                        ? new Intl.NumberFormat("en-US").format(Number(trimmedRestakingPool360APY))
                        : "0"}
                      {"%"}
                    </Typography>
                  ) : (
                    <Box display="flex" alignItems="center" justifyContent="center" sx={{ width: "100%" }}>
                      <Skeleton width="150px" data-testid="apy-loading" />
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box>
                  <Typography
                    sx={{
                      color: "rgba(255, 255, 255, 0.60)",
                      fontSize: "18px",
                      fontWeight: "400",
                      mb: "10px",
                    }}
                    align="center"
                  >
                    <Trans>APY(180Day)</Trans>
                  </Typography>
                  {restakingPool180APY ? (
                    <Typography
                      sx={{
                        fontSize: "24px",
                        fontWeight: "600",
                        color: "#EAECEF",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                      align="center"
                    >
                      {Number(trimmedRestakingPool180APY) >= 0
                        ? new Intl.NumberFormat("en-US").format(Number(trimmedRestakingPool180APY))
                        : "0"}
                      {"%"}
                    </Typography>
                  ) : (
                    <Box display="flex" alignItems="center" justifyContent="center" sx={{ width: "100%" }}>
                      <Skeleton width="150px" data-testid="apy-loading" />
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Box>
                  <Typography
                    sx={{
                      color: "rgba(255, 255, 255, 0.60)",
                      fontSize: "18px",
                      fontWeight: "400",
                      mb: "10px",
                    }}
                    align="center"
                  >
                    <Trans>APY(90Day)</Trans>
                  </Typography>
                  {restakingPool90APY ? (
                    <Typography
                      sx={{
                        fontSize: "24px",
                        fontWeight: "600",
                        color: "#EAECEF",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                      }}
                      align="center"
                    >
                      {Number(trimmedRestakingPool90APY) >= 0
                        ? new Intl.NumberFormat("en-US").format(Number(trimmedRestakingPool90APY))
                        : "0"}
                      {"%"}
                    </Typography>
                  ) : (
                    <Box display="flex" alignItems="center" justifyContent="center" sx={{ width: "100%" }}>
                      <Skeleton width="150px" data-testid="apy-loading" />
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Grid
          container
          columnSpacing={2}
          sx={{
            display: { xs: "none", sm: "flex" },
          }}
        >
          <Grid
            item
            xs={12}
            sm={3}
            sx={{
              height: "1px",
            }}
          />
          <Grid item xs={12} sm={9}>
            <Box
              sx={{
                mb: { sm: "20px", xs: "15px" },
              }}
            >
              <Tabs
                value={tab}
                onChange={changeTab}
                sx={{
                  borderBottom: "1px solid #2d2d2d",
                  "& .MuiTabs-indicator": {
                    background: "#fff",
                  },
                }}
                variant="scrollable"
              >
                <Tab
                  label={t`360Day`}
                  sx={{
                    color: "#848E9C",
                    fontSize: "16px",
                    fontWeight: "400",
                    textTransform: "capitalize",
                    "&.Mui-selected": {
                      color: "#EAECEF",
                      fontWeight: "600",
                    },
                  }}
                />
                <Tab
                  label={t`180Day`}
                  sx={{
                    color: "#848E9C",
                    fontSize: "16px",
                    fontWeight: "400",
                    textTransform: "capitalize",
                    "&.Mui-selected": {
                      color: "#EAECEF",
                      fontWeight: "600",
                    },
                  }}
                />
                <Tab
                  label={t`90Day`}
                  sx={{
                    color: "#848E9C",
                    fontSize: "16px",
                    fontWeight: "400",
                    textTransform: "capitalize",
                    "&.Mui-selected": {
                      color: "#EAECEF",
                      fontWeight: "600",
                    },
                  }}
                />
              </Tabs>
            </Box>
          </Grid>
        </Grid>
        {/* restake bottom */}
        <Grid
          container
          columnSpacing={2}
          sx={{
            mb: { xs: "20px", sm: "40px" },
          }}
        >
          {/* grid left */}
          <Grid
            item
            xs={12}
            sm={3}
            sx={{
              mb: { xs: "8px", sm: "0" },
              // mt: {
              //   sm: '69px', xs: '0'
              // },
              background: { sm: "#151515", xs: "transparent" },
              borderRadius: "10px",
              border: { sm: "1px solid #2D2D2D", xs: "none" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                borderRadius: "10px",
                border: { xs: "1px solid #2D2D2D", sm: "none" },
                background: {
                  xs: "#151515",
                  sm: "transparent",
                },
                height: { xs: "72px", sm: "105px" },
                pr: { xs: "15px", sm: "20px" },
                pl: { xs: "15px", sm: "0" },
                py: { sm: "22px" },
                mb: { xs: "8px", sm: "0px" },
              }}
              display={"flex"}
              alignItems={{ xs: "center", sm: "flex-start" }}
            >
              <Box>
                <Box
                  sx={{
                    mb: { sm: "8px", xs: "6px" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "18px" },
                      color: "#848e9c",
                      fontWeight: "400",
                    }}
                  >
                    <Trans>Total Value Deposited</Trans>(360)
                  </Typography>
                </Box>
                {staking360TVL >= 0 ? (
                  <Typography
                    sx={{
                      color: "#eaecef",
                      fontSize: { xs: "16px", sm: "24px" },
                      fontStyle: "normal",
                      fontWeight: "600",
                      width: "100%",
                    }}
                  >
                    <span data-testid="tvl-value">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                      }).format(staking360TVL)}
                    </span>
                  </Typography>
                ) : (
                  <Box
                    display="flex"
                    alignItems="center"
                    // justifyContent="center"
                    sx={{ width: "100%" }}
                  >
                    <Skeleton width="150px" data-testid="tvl-loading" />
                  </Box>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                borderRadius: "10px",
                border: { xs: "1px solid #2D2D2D", sm: "none" },
                background: {
                  xs: "#151515",
                  sm: "transparent",
                },
                height: { xs: "72px", sm: "105px" },
                pr: { xs: "15px", sm: "20px" },
                pl: { xs: "15px", sm: "0" },
                py: { sm: "22px" },
                mb: { xs: "8px", sm: "0px" },
              }}
              display={"flex"}
              alignItems={{ xs: "center", sm: "flex-start" }}
            >
              <Box>
                <Box
                  sx={{
                    mb: { sm: "8px", xs: "6px" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "18px" },
                      color: "#848e9c",
                      fontWeight: "400",
                    }}
                  >
                    <Trans>Total Value Deposited</Trans>(180)
                  </Typography>
                </Box>
                {staking180TVL >= 0 ? (
                  <Typography
                    sx={{
                      color: "#eaecef",
                      fontSize: { xs: "16px", sm: "24px" },
                      fontStyle: "normal",
                      fontWeight: "600",
                      width: "100%",
                    }}
                  >
                    <span data-testid="tvl-value">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                      }).format(staking180TVL)}
                    </span>
                  </Typography>
                ) : (
                  <Box
                    display="flex"
                    alignItems="center"
                    // justifyContent="center"
                    sx={{ width: "100%" }}
                  >
                    <Skeleton width="150px" data-testid="tvl-loading" />
                  </Box>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                borderRadius: "10px",
                border: { xs: "1px solid #2D2D2D", sm: "none" },
                background: {
                  xs: "#151515",
                  sm: "transparent",
                },
                height: { xs: "72px", sm: "105px" },
                pr: { xs: "15px", sm: "20px" },
                pl: { xs: "15px", sm: "0" },
                py: { sm: "22px" },
                mb: { xs: "8px", sm: "0px" },
              }}
              display={"flex"}
              alignItems={{ xs: "center", sm: "flex-start" }}
            >
              <Box>
                <Box
                  sx={{
                    mb: { sm: "8px", xs: "6px" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "18px" },
                      color: "#848e9c",
                      fontWeight: "400",
                    }}
                  >
                    <Trans>Total Value Deposited</Trans>(90)
                  </Typography>
                </Box>
                {staking90TVL >= 0 ? (
                  <Typography
                    sx={{
                      color: "#eaecef",
                      fontSize: { xs: "16px", sm: "24px" },
                      fontStyle: "normal",
                      fontWeight: "600",
                      width: "100%",
                    }}
                  >
                    <span data-testid="tvl-value">
                      {new Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                        maximumFractionDigits: 0,
                        minimumFractionDigits: 0,
                      }).format(staking90TVL)}
                    </span>
                  </Typography>
                ) : (
                  <Box
                    display="flex"
                    alignItems="center"
                    // justifyContent="center"
                    sx={{ width: "100%" }}
                  >
                    <Skeleton width="150px" data-testid="tvl-loading" />
                  </Box>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                borderRadius: "10px",
                border: { xs: "1px solid #2D2D2D", sm: "none" },
                background: {
                  xs: "#151515",
                  sm: "transparent",
                },
                height: { xs: "72px", sm: "105px" },
                pr: { xs: "15px", sm: "20px" },
                pl: { xs: "15px", sm: "0" },
                py: { sm: "22px" },
                mb: { xs: "8px", sm: "0px" },
              }}
              display={"flex"}
              alignItems={{ xs: "center", sm: "flex-start" }}
            >
              <Box>
                <Box
                  sx={{
                    mb: { sm: "8px", xs: "6px" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "18px" },
                      color: "#848e9c",
                      fontWeight: "400",
                    }}
                  >
                    <Trans>Restaked(My Account)</Trans>
                  </Typography>
                </Box>
                {address ? (
                  Number(totalRestakingPrincipal) >= 0 ? (
                    <Typography
                      sx={{
                        color: "#eaecef",
                        fontSize: { xs: "16px", sm: "24px" },
                        fontStyle: "normal",
                        fontWeight: "600",
                        width: "100%",
                      }}
                    >
                      <span data-testid="index-value">
                        {Number(totalRestakingPrincipal) >= 0.0001
                          ? customNumberFormat(Number(totalRestakingPrincipal), 4)
                          : "0"}
                        {""}
                        sNVB
                      </span>
                    </Typography>
                  ) : (
                    <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                      <Skeleton width="150px" data-testid="tvl-loading" />
                    </Box>
                  )
                ) : (
                  <Typography
                    sx={{
                      color: "#eaecef",
                      fontSize: { xs: "16px", sm: "24px" },
                      fontStyle: "normal",
                      fontWeight: "600",
                      width: "100%",
                    }}
                  >
                    <span data-testid="index-value">0 sNVB</span>
                  </Typography>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                borderRadius: "10px",
                border: { xs: "1px solid #2D2D2D", sm: "none" },
                background: {
                  xs: "#151515",
                  sm: "transparent",
                },
                height: { xs: "72px", sm: "105px" },
                pr: { xs: "15px", sm: "20px" },
                pl: { xs: "15px", sm: "0" },
                py: { sm: "22px" },
                mb: { xs: "8px", sm: "0px" },
              }}
              display={"flex"}
              alignItems={{ xs: "center", sm: "flex-start" }}
            >
              <Box>
                <Box
                  sx={{
                    mb: { sm: "8px", xs: "6px" },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "18px" },
                      color: "#848e9c",
                      fontWeight: "400",
                    }}
                  >
                    <Trans>Interest(My Account)</Trans>
                  </Typography>
                </Box>
                {address ? (
                  Number(totalRestakingWithdrawableInterest) >= 0 ? (
                    <Typography
                      sx={{
                        color: "#eaecef",
                        fontSize: { xs: "16px", sm: "24px" },
                        fontStyle: "normal",
                        fontWeight: "600",
                        width: "100%",
                      }}
                    >
                      <span data-testid="index-value">
                        {Number(totalRestakingWithdrawableInterest) >= 0.0001
                          ? customNumberFormat(Number(totalRestakingWithdrawableInterest), 4)
                          : "0"}
                        {""}
                        sNVB
                      </span>
                    </Typography>
                  ) : (
                    <Box display="flex" alignItems="center" sx={{ width: "100%" }}>
                      <Skeleton width="150px" data-testid="tvl-loading" />
                    </Box>
                  )
                ) : (
                  <Typography
                    sx={{
                      color: "#eaecef",
                      fontSize: { xs: "16px", sm: "24px" },
                      fontStyle: "normal",
                      fontWeight: "600",
                      width: "100%",
                    }}
                  >
                    <span data-testid="index-value">0 sNVB</span>
                  </Typography>
                )}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={0} sx={{ display: { xs: "block", sm: "none" } }}>
            <Box
              sx={{
                mb: { sm: "20px", xs: "15px" },
                display: { xs: "block", sm: "none" },
              }}
            >
              <Tabs
                value={tab}
                onChange={changeTab}
                sx={{
                  borderBottom: "1px solid #2d2d2d",
                  "& .MuiTabs-indicator": {
                    background: "#fff",
                  },
                }}
                variant="scrollable"
              >
                <Tab
                  label={t`360Day`}
                  sx={{
                    color: "#848E9C",
                    fontSize: "16px",
                    fontWeight: "400",
                    textTransform: "capitalize",
                    "&.Mui-selected": {
                      color: "#EAECEF",
                      fontWeight: "600",
                    },
                  }}
                />
                <Tab
                  label={t`180Day`}
                  sx={{
                    color: "#848E9C",
                    fontSize: "16px",
                    fontWeight: "400",
                    textTransform: "capitalize",
                    "&.Mui-selected": {
                      color: "#EAECEF",
                      fontWeight: "600",
                    },
                  }}
                />
                <Tab
                  label={t`90Day`}
                  sx={{
                    color: "#848E9C",
                    fontSize: "16px",
                    fontWeight: "400",
                    textTransform: "capitalize",
                    "&.Mui-selected": {
                      color: "#EAECEF",
                      fontWeight: "600",
                    },
                  }}
                />
              </Tabs>
            </Box>
          </Grid>
          {/* grid right */}
          <Grid item xs={12} sm={9}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                borderRadius: { xs: "6px", sm: "10px" },
                border: "1px solid #2D2D2D",
                background: "#151515",
                // pb: "20px",
              }}
            >
              {/* stake tab */}
              <Box>
                <Tabs
                  value={view}
                  onChange={changeView}
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{
                    borderBottom: "1px solid #2d2d2d",
                    "& .MuiTabs-indicator": {
                      background: "#fff",
                    },
                  }}
                >
                  <Tab
                    label={t`Flash Staking`}
                    sx={{
                      color: "#848E9C",
                      fontSize: { xs: "14px", sm: "16px" },
                      fontWeight: "400",
                      "&.Mui-selected": {
                        color: "#eaecef",
                        fontWeight: "600",
                      },
                    }}
                  />
                  <Tab
                    label={t`COMPLEX STAKING`}
                    sx={{
                      color: "#848E9C",
                      fontSize: { xs: "14px", sm: "16px" },
                      fontWeight: "400",
                      "&.Mui-selected": {
                        color: "#eaecef",
                        fontWeight: "600",
                      },
                    }}
                  />
                  <Tab
                    label={t`Unrestake INTEREST`}
                    sx={{
                      color: "#848E9C",
                      fontSize: { xs: "14px", sm: "16px" },
                      fontWeight: "400",
                      "&.Mui-selected": {
                        color: "#eaecef",
                        fontWeight: "600",
                      },
                    }}
                  />
                </Tabs>
              </Box>
              {/*  stake action  */}
              {/* {view !== 2 ? ( */}
              <Box
                display="flex"
                alignItems={"center"}
                justifyContent={"center"}
                flexDirection={"column"}
                sx={{
                  px: {
                    sm: "30px",
                    xs: "15px",
                  },
                  // height: "144px",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: { sm: "170px", xs: "auto" },
                  }}
                  display="flex"
                  alignItems={"center"}
                  flexDirection={"column"}
                  justifyContent={view == 1 ? "flex-start" : "center"}
                >
                  <Box
                    sx={{
                      height: "65px",
                      width: "100%",
                    }}
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"space-between"}
                  >
                    <Box display={"flex"} alignItems={"center"}>
                      {view === 0 && (
                        <>
                          <Typography
                            sx={{
                              color: "#848E9C",
                              fontSize: {
                                sm: "18px",
                                xs: "14px",
                              },
                              fontWeight: "400",
                            }}
                          >
                            <Trans>Balance:</Trans>
                          </Typography>
                          {address ? (
                            usdtBalance ? (
                              <Typography
                                sx={{
                                  color: "#EAECEF",
                                  fontSize: {
                                    sm: "18px",
                                    xs: "14px",
                                  },
                                  fontWeight: "400",
                                }}
                              >
                                {Number(usdtBalance) >= 0.0001 ? customNumberFormat(Number(usdtBalance), 4) : 0} USDT
                              </Typography>
                            ) : (
                              <Skeleton width="80px" />
                            )
                          ) : (
                            <Typography
                              sx={{
                                color: "#EAECEF",
                                fontSize: {
                                  sm: "18px",
                                  xs: "14px",
                                },
                                fontWeight: "400",
                              }}
                            >
                              0 USDT
                            </Typography>
                          )}
                        </>
                      )}
                      {view == 2 && (
                        <>
                          <Typography
                            sx={{
                              color: "#848E9C",
                              fontSize: {
                                sm: "18px",
                                xs: "14px",
                              },
                              fontWeight: "400",
                            }}
                          >
                            <Trans>Restaking Interest Balance</Trans>:
                          </Typography>
                          {address ? (
                            Number(restakingWithdrawableInterest?.[tab]) >= 0 ? (
                              <Typography
                                sx={{
                                  color: "#EAECEF",
                                  fontSize: {
                                    sm: "18px",
                                    xs: "14px",
                                  },
                                  fontWeight: "400",
                                }}
                              >
                                {Number(restakingWithdrawableInterest?.[tab]) >= 0.0001
                                  ? customNumberFormat(Number(restakingWithdrawableInterest?.[tab]), 4)
                                  : 0}{" "}
                                sNVB
                              </Typography>
                            ) : (
                              <Skeleton width="80px" />
                            )
                          ) : (
                            <Typography
                              sx={{
                                color: "#EAECEF",
                                fontSize: {
                                  sm: "18px",
                                  xs: "14px",
                                },
                                fontWeight: "400",
                              }}
                            >
                              0 sNVB
                            </Typography>
                          )}
                        </>
                      )}
                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="center">
                      {view == 0 && (
                        <Box
                          sx={{
                            mr: "20px",
                          }}
                        >
                          <IconButton onClick={handleOpen}>
                            <SvgIcon sx={{ color: "#C7C8CC" }} component={SettingsIcon} />
                          </IconButton>
                          <AdvancedSettings
                            open={open}
                            handleClose={handleClose}
                            slippage={slippage}
                            onSlippageChange={onSlippageChange}
                            onSlippageBlur={onSlippageBlur}
                            isBtn={isBtn}
                          />
                        </Box>
                      )}
                      {view !== 2 && (
                        <Box
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          sx={{
                            cursor: "pointer",
                          }}
                          onClick={handleOpenModal}
                        >
                          <SvgIcon
                            sx={{
                              width: { sm: "32px", xs: "24px" },
                              height: { sm: "32px", xs: "24px" },
                            }}
                            viewBox="0 0 24 24"
                            component={CalcIcon}
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      // py: "50px",
                      height: { sm: "100%", xs: "auto" },
                      width: "100%",
                    }}
                    display="flex"
                    alignItems={"center"}
                    justifyContent={"center"}
                    flexDirection={{
                      xs: "column",
                      sm: "row",
                    }}
                  >
                    {!address && view !== 2 ? (
                      <Box
                        sx={{
                          width: "100%",
                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                      >
                        <Box
                          sx={{
                            width: "200px",
                            borderRadius: "6px",
                            height: "42px",
                            border: "1px solid #000",
                            background: "#FCD000",
                            boxShadow: "-3px 3px 0px 0px #ECAA00",
                            mb: { xs: "10px", sm: "20px" },
                            "&:hover": {
                              transform: "scale(1.02)",
                            },
                            // "&:hover": {
                            //   transform: "scale(1.02)",
                            // },
                          }}
                        >
                          <Button
                            sx={{
                              width: "100%",
                              height: "100%",
                              background: "transparent",
                              "&:hover": {
                                background: "transparent",
                              },
                            }}
                            onClick={connect}
                            variant="contained"
                          >
                            <Typography
                              sx={{
                                color: "#000",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              <Trans>Connect Wallet</Trans>
                            </Typography>
                          </Button>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              color: "#848E9C",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            {view == 0 ? (
                              <Trans>Connect your wallet to restake NVB</Trans>
                            ) : (
                              <Trans>Connect your wallet to restake NVB</Trans>
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    ) : address && !isAllowanceDataLoading ? (
                      ((!hasAllowance("USDT") || (hasAllowance("USDT") && Number(flashRestakingSohmAllowance) <= 0)) &&
                        view === 0) ||
                      (!hasAllowance("sOHM") && view === 1) ? (
                        <Box
                          sx={{
                            mb: isSmallScreen ? 2.5 : 0,
                            px: isSmallScreen ? 2.5 : 0,
                            width: { xs: "100%", sm: "60%" },
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#848E9C",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                            align="center"
                          >
                            {view === 0 && (
                              <>
                                <Trans>First time buy NVB to restaking</Trans>?
                                <br />
                                <Trans>Please approve NovaBank to use your USDT Buy NVB.</Trans>
                              </>
                            )}
                            {view === 1 && (
                              <>
                                <Trans>First time restaking NVB</Trans>?
                                <br />
                                <Trans>Please approve NovaBank to use your NVB for restaking.</Trans>
                              </>
                            )}
                          </Typography>
                        </Box>
                      ) : (
                        <FormControl
                          variant="outlined"
                          color="primary"
                          sx={{
                            px: 0,
                            width: "100%",
                            "&.ohm-input": {
                              m: isSmallScreen ? "0 !important" : 0,
                              mb: isSmallScreen ? "20px !important" : 0,
                            },
                            mb: { xs: "20px", sm: "0" },
                          }}
                        >
                          <OutlinedInput
                            id="amount-input"
                            type="number"
                            placeholder={t`Enter an amount`}
                            className="stake-input"
                            value={quantity}
                            onChange={onAmountChange}
                            sx={{
                              height: "44px",
                              borderRadius: "6px",
                              border: "1px solid #2D2D2D",
                              background: "#0c0c0c",
                              color: "#fff",
                            }}
                            endAdornment={
                              <InputAdornment position="end">
                                <Button
                                  sx={{
                                    color: "#FCD000",
                                    textAlign: "right",
                                    fontSize: "16px",
                                    fontWeight: "400",
                                  }}
                                  variant="text"
                                  onClick={setMax}
                                >
                                  <Trans>Max</Trans>
                                </Button>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      )
                    ) : view == 2 ? (
                      <Box
                        sx={{
                          width: "100%",
                        }}
                        display="flex"
                        alignItems={"center"}
                        justifyContent={"center"}
                        flexDirection={"column"}
                      >
                        <Box
                          sx={{
                            width: "200px",
                            borderRadius: "6px",
                            height: "42px",
                            border: "1px solid #000",
                            background: "#FCD000",
                            boxShadow: "-3px 3px 0px 0px #ECAA00",
                            mb: { xs: "20px", sm: "20px" },
                            "&:hover": {
                              transform: "scale(1.02)",
                            },
                          }}
                        >
                          <Button
                            sx={{
                              width: "100%",
                              height: "100%",
                              background: "transparent",
                              "&:hover": {
                                background: "transparent",
                              },
                            }}
                            onClick={connect}
                            variant="contained"
                          >
                            <Typography
                              sx={{
                                color: "#000",
                                fontSize: "14px",
                                fontWeight: "500",
                              }}
                            >
                              <Trans>Connect Wallet</Trans>
                            </Typography>
                          </Button>
                        </Box>
                        <Box>
                          <Typography
                            sx={{
                              color: "#848E9C",
                              fontSize: "14px",
                              fontWeight: "400",
                            }}
                          >
                            <Trans>Connect your wallet to unrestake interest</Trans>
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Skeleton width="150px" />
                    )}
                    {address &&
                      view == 0 &&
                      (isAllowanceDataLoading ? (
                        ""
                      ) : !hasAllowance("USDT") ||
                        (quantity && flashRestakingUsdtAllowance && Number(quantity) > flashRestakingUsdtAllowance) ? (
                        // First approve USDT
                        <Box
                          sx={{
                            mb: { xs: "20px", sm: "0" },
                            width: { xs: "100%", sm: "auto" },
                          }}
                        >
                          <Box
                            sx={{
                              width: { xs: "100%", sm: "200px" },
                              borderRadius: "6px",
                              height: "44px",
                              border: "1px solid #000",
                              background: "#FCD000",
                              boxShadow: "-3px 3px 0px 0px #ECAA00",
                              mb: { xs: "10px", sm: "0" },
                              ml: { sm: "16px", xs: "0" },
                              "&:hover": {
                                transform: "scale(1.02)",
                              },
                            }}
                          >
                            <LoadingButton
                              variant="contained"
                              disabled={isPendingTxn(pendingTransactions, "approve_flashRestaking")}
                              loading={isPendingTxn(pendingTransactions, "approve_flashRestaking")}
                              loadingPosition="end"
                              onClick={() => {
                                onSeekApproval("USDT", true);
                              }}
                              sx={{
                                width: "100%",
                                height: "100%",
                                background: "transparent",
                                color: "#000",
                                "&:hover": {
                                  background: "transparent",
                                },
                              }}
                            >
                              {txnButtonText(pendingTransactions, "approve_flashRestaking", t`Approve USDT`)}
                            </LoadingButton>
                          </Box>
                        </Box>
                      ) : hasAllowance("USDT") &&
                        (!quantity ||
                          (flashRestakingUsdtAllowance && flashRestakingUsdtAllowance >= Number(quantity))) &&
                        !hasAllowance("sOHM") ? (
                        // USDT approved and sufficient, now approve sOHM
                        <Box
                          sx={{
                            p: 0,
                            ml: { xs: "0", sm: "16px" },
                            mb: { xs: "20px", sm: "0" },
                            width: { xs: "100%", sm: "auto" },
                          }}
                        >
                          <Box
                            sx={{
                              width: { xs: "100%", sm: "200px" },
                              borderRadius: "6px",
                              height: "44px",
                              border: "1px solid #000",
                              background: "#FCD000",
                              boxShadow: "-3px 3px 0px 0px #ECAA00",
                              mb: { xs: "10px", sm: "0" },
                              "&:hover": {
                                transform: "scale(1.02)",
                              },
                            }}
                          >
                            <LoadingButton
                              variant="contained"
                              disabled={isPendingTxn(pendingTransactions, "approve_flashRestaking")}
                              loading={isPendingTxn(pendingTransactions, "approve_flashRestaking")}
                              loadingPosition="end"
                              onClick={() => {
                                onSeekApproval("sOhm", true);
                              }}
                              sx={{
                                width: "100%",
                                height: "100%",
                                background: "transparent",
                                color: "#000",
                                "&:hover": {
                                  background: "transparent",
                                },
                              }}
                            >
                              {txnButtonText(pendingTransactions, "approve_flashRestaking", t`Approve sNVB`)}
                            </LoadingButton>
                          </Box>
                        </Box>
                      ) : (
                        // Both tokens approved, show Buy And Restake button
                        <Box
                          sx={{
                            mb: { xs: "20px", sm: "0" },
                            width: { xs: "100%", sm: "auto" },
                            ml: { xs: "0", sm: "16px" },
                          }}
                        >
                          <Box
                            sx={{
                              width: { xs: "100%", sm: "200px" },
                              borderRadius: "6px",
                              height: "44px",
                              border: "1px solid #000",
                              background: "#FCD000",
                              boxShadow: "-3px 3px 0px 0px #ECAA00",
                              mb: { xs: "10px", sm: "0" },
                              "&:hover": {
                                transform: "scale(1.02)",
                              },
                            }}
                          >
                            <LoadingButton
                              variant="contained"
                              disabled={isPendingTxn(pendingTransactions, "flashRestaking") || Number(quantity) == 0}
                              loading={isPendingTxn(pendingTransactions, "flashRestaking")}
                              loadingPosition="end"
                              onClick={() => {
                                onChangeRestake("flashRestaking");
                              }}
                              sx={{
                                width: "100%",
                                height: "100%",
                                background: "transparent",
                                color: "#000",
                                "&:hover": {
                                  background: "transparent",
                                },
                              }}
                            >
                              {txnButtonText(pendingTransactions, "flashRestaking", t`Buy And Restake`)}
                            </LoadingButton>
                          </Box>
                        </Box>
                      ))}
                    {address &&
                      view == 1 &&
                      (isAllowanceDataLoading ? (
                        <Skeleton />
                      ) : !hasAllowance("OHM") ||
                        (quantity &&
                          flashRestakingOhmAllowance &&
                          Number(quantity) > Number(flashRestakingOhmAllowance)) ? (
                        // First approve OHM or OHM allowance insufficient
                        <Box
                          sx={{
                            p: 0,
                            ml: { xs: "0", sm: "16px" },
                            mb: { xs: "20px", sm: "0" },
                            width: { xs: "100%", sm: "auto" },
                          }}
                        >
                          <Box
                            sx={{
                              width: { xs: "100%", sm: "200px" },
                              borderRadius: "6px",
                              height: "44px",
                              border: "1px solid #000",
                              background: "#FCD000",
                              boxShadow: "-3px 3px 0px 0px #ECAA00",
                              mb: { xs: "10px", sm: "0" },
                              "&:hover": {
                                transform: "scale(1.02)",
                              },
                            }}
                          >
                            <LoadingButton
                              variant="contained"
                              disabled={isPendingTxn(pendingTransactions, "approve_restaking")}
                              loading={isPendingTxn(pendingTransactions, "approve_restaking")}
                              loadingPosition="end"
                              onClick={() => {
                                onSeekApproval("ohm", false);
                              }}
                              sx={{
                                width: "100%",
                                height: "100%",
                                background: "transparent",
                                color: "#000",
                                "&:hover": {
                                  background: "transparent",
                                },
                              }}
                            >
                              {txnButtonText(pendingTransactions, "approve_restaking", t`Approve NVB`)}
                            </LoadingButton>
                          </Box>
                        </Box>
                      ) : hasAllowance("OHM") &&
                        (!hasAllowance("sOHM") ||
                          (quantity &&
                            restakingAllowance?.[tab] &&
                            Number(quantity) > Number(restakingAllowance?.[tab]))) ? (
                        // OHM approved, now approve sOHM or sOHM allowance insufficient
                        <Box
                          sx={{
                            p: 0,
                            ml: { xs: "0", sm: "16px" },
                            mb: { xs: "20px", sm: "0" },
                            width: { xs: "100%", sm: "auto" },
                          }}
                        >
                          <Box
                            sx={{
                              width: { xs: "100%", sm: "200px" },
                              borderRadius: "6px",
                              height: "44px",
                              border: "1px solid #000",
                              background: "#FCD000",
                              boxShadow: "-3px 3px 0px 0px #ECAA00",
                              mb: { xs: "10px", sm: "0" },
                              "&:hover": {
                                transform: "scale(1.02)",
                              },
                            }}
                          >
                            <LoadingButton
                              variant="contained"
                              disabled={isPendingTxn(pendingTransactions, "approve_restaking")}
                              loading={isPendingTxn(pendingTransactions, "approve_restaking")}
                              loadingPosition="end"
                              onClick={() => {
                                onSeekApproval("sOhm", false);
                              }}
                              sx={{
                                width: "100%",
                                height: "100%",
                                background: "transparent",
                                color: "#000",
                                "&:hover": {
                                  background: "transparent",
                                },
                              }}
                            >
                              {txnButtonText(pendingTransactions, "approve_restaking", t`Approve sNVB`)}
                            </LoadingButton>
                          </Box>
                        </Box>
                      ) : (
                        // Both tokens approved and allowances are sufficient, show Restake button
                        <Box
                          sx={{
                            p: 0,
                            ml: { xs: "0", sm: "16px" },
                            mb: { xs: "20px", sm: "0" },
                            width: { xs: "100%", sm: "auto" },
                          }}
                        >
                          <Box
                            sx={{
                              width: {
                                xs: "100%",
                                sm: "200px",
                              },
                              height: "44px",
                              borderRadius: "6px",
                              border: "1px solid #000",
                              background: "#FCD000",
                              boxShadow: "-3px 3px 0px 0px #ECAA00",
                              mb: { xs: "10px", sm: "0" },
                              "&:hover": {
                                transform: "scale(1.02)",
                              },
                            }}
                          >
                            <LoadingButton
                              variant="contained"
                              disabled={isPendingTxn(pendingTransactions, "restaking") || Number(quantity) == 0}
                              loading={isPendingTxn(pendingTransactions, "restaking")}
                              loadingPosition="end"
                              onClick={() => {
                                onChangeRestake("restaking");
                              }}
                              sx={{
                                width: "100%",
                                height: "100%",
                                background: "transparent",
                                color: "#000",
                                "&:hover": {
                                  background: "transparent",
                                },
                              }}
                            >
                              {txnButtonText(pendingTransactions, "restaking", t`Restake`)}
                            </LoadingButton>
                          </Box>
                        </Box>
                      ))}
                    {address && view == 2 && (
                      <Box
                        sx={{
                          ml: { xs: "0", sm: "16px" },
                          width: { xs: "100%", sm: "auto" },
                          mb: { xs: "20px", sm: "0" },
                        }}
                      >
                        <Box
                          sx={{
                            width: {
                              xs: "100%",
                              sm: "200px",
                            },
                            // ml: { xs: "0", sm: "16px" },
                            height: "44px",
                            borderRadius: "6px",
                            border: "1px solid #000",
                            background: "#FCD000",
                            boxShadow: "-3px 3px 0px 0px #ECAA00",
                            mb: { xs: "10px", sm: "0" },
                            "&:hover": {
                              transform: "scale(1.02)",
                            },
                          }}
                        >
                          <LoadingButton
                            variant="contained"
                            disabled={isPendingTxn(pendingTransactions, "unrestaking_interest")}
                            loading={isPendingTxn(pendingTransactions, "unrestaking_interest")}
                            loadingPosition="end"
                            onClick={() => {
                              onUnrestakeInterest();
                            }}
                            sx={{
                              width: "100%",
                              height: "100%",
                              background: "transparent",
                              color: "#000",
                              "&:hover": {
                                background: "transparent",
                              },
                            }}
                          >
                            {txnButtonText(pendingTransactions, "unrestaking_interest", t`Unrestake`)}
                          </LoadingButton>
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                  }}
                >
                  {/* account balance */}
                  <Box
                    sx={{
                      width: "100%",
                      borderBottom: "1px solid #2d2d2d",
                      mb: "16px",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        mb: "16px",
                      }}
                      display={"flex"}
                      alignItems="center"
                      justifyContent={"space-between"}
                    >
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        <Trans>Unrestaked Balance</Trans>
                      </Typography>
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {isAppLoading ? (
                          <Skeleton width="80px" />
                        ) : (
                          <>{customNumberFormat(Number(ohmBalance), 4)} NVB</>
                        )}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        mb: "16px",
                      }}
                      display={"flex"}
                      alignItems="center"
                      justifyContent={"space-between"}
                    >
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        <Trans>Restaked Balance</Trans>
                      </Typography>
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {isAppLoading ? (
                          <Skeleton width="80px" />
                        ) : (
                          <>{customNumberFormat(Number(restakedBal[tab]), 4)} sNVB</>
                        )}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        mb: "16px",
                      }}
                      display={"flex"}
                      alignItems="center"
                      justifyContent={"space-between"}
                    >
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        <Trans>Restaking Interest Balance</Trans>
                      </Typography>
                      {address ? (
                        Number(restakingWithdrawableInterest?.[tab]) >= 0 ? (
                          <Typography
                            sx={{
                              color: "#EAECEF",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            {Number(restakingWithdrawableInterest?.[tab]) >= 0.0001
                              ? customNumberFormat(Number(restakingWithdrawableInterest?.[tab]), 4)
                              : 0}{" "}
                            sNVB
                          </Typography>
                        ) : (
                          <Skeleton width="80px" />
                        )
                      ) : (
                        <Typography
                          sx={{
                            color: "#EAECEF",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          0 sNVB
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  {/* reward data */}
                  <Box
                    sx={{
                      width: "100%",
                      mb: "24px",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        mb: "16px",
                      }}
                      display={"flex"}
                      alignItems="center"
                      justifyContent={"space-between"}
                    >
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        <Trans>Next Reward Amount</Trans>
                      </Typography>
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {isAppLoading ? <Skeleton width="80px" /> : <>{nextRewardValue} sNVB</>}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        mb: "16px",
                      }}
                      display={"flex"}
                      alignItems="center"
                      justifyContent={"space-between"}
                    >
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        <Trans>Next Reward Yield</Trans>
                      </Typography>
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        {isAppLoading ? <Skeleton width="80px" /> : <>{nextRebaseValue}%</>}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        width: "100%",
                        mb: "16px",
                      }}
                      display={"flex"}
                      alignItems="center"
                      justifyContent={"space-between"}
                    >
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        <Trans>ROI (5-Day Rate)</Trans>
                      </Typography>
                      <Typography
                        sx={{
                          color: "#EAECEF",
                          fontSize: "14px",
                          fontWeight: "500",
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                        }}
                      >
                        {isAppLoading ? (
                          <Skeleton width="80px" />
                        ) : (
                          <>{trim(toolNumber(Number(restakeFiveDayRate) * 100), 4)}%</>
                        )}
                      </Typography>
                    </Box>
                  </Box>
                  {/* desc */}
                </Box>
              </Box>
              {/* ) : (
                <ClaimInterest />
              )} */}
            </Box>
          </Grid>
        </Grid>
        {/* restake record */}
        <RestakeRecord />
      </Box>
      <CalculatorModal open={modalOpen} handleClose={handleCloseModal} stakingRebasePercentage={nextRebaseValue} />
    </Box>
  );
};

export default Restake;
